<template lang="pug">
div(class='Contacts')
	NuxtLink(
		v-if='contacts.phone && greaterThan("mobileWide")',
		class='Phone',
		:href='$f.tel(contacts.phone)'
	) {{ contacts.phone }}

	div(class='Social')
		a(
			v-for='messenger in messengersState',
			:key='messenger.id',
			:class='messenger.title',
			target='_blank',
			:href='messenger.link'
		)
			UiIcon(:name='messenger.icon', :size='greaterThan("mobile") ? "md" : "sm"')
</template>

<script lang="ts" setup>
const { greaterThan } = usePlatform();
const { fetchContacts, contacts } = useContacts();
const { fetchMessengers, messengersState } = useMessengers();

await Promise.all([fetchContacts(), fetchMessengers()]);
</script>

<style lang="less" scoped>
.Contacts {
	.box(grid; auto; auto; none; 1rem; 1fr; auto; center; center; column);

	& > .Phone {
		.text(@ColorBase; 1em 0.875rem @medium; none; none none);
	}

	& > .Social {
		.box(grid; auto; auto; none; 0.5rem; 1fr; auto; center; center; column);

		& > a {
			.text(@ColorBase; 1rem 1rem @medium; none; none none);
			.border-radius(100rem);
			.box(grid; 1.75rem; 1.75rem; fade(@ColorWhite, 50%); 0; 1fr; 1fr; center; center);
			.transition(all; 250ms; 'sine');

			&.whatsapp {
				.cursor(pointer);
				.text(@ColorWhite);
				.background(@ColorWhatsapp);
			}
			&.telegram {
				.cursor(pointer);
				.text(@ColorWhite);
				.background(@ColorTelegram);
			}
			&.max {
				.cursor(pointer);
				.text(@ColorWhite);
				.gradient(70; @ColorMax0; @ColorMax20 20% @ColorMax50 50%; @ColorMax80 80%; @ColorMax100);
			}
		}
	}

	/**
	* >= 400px
	*/
	@media all and (min-width: @mobile-small) {
		& > .Social {
			.box(grid; auto; auto; none; 0.75rem; 1fr; auto; center; center; column);
			& > a {
				.box(grid; 2rem; 2rem; fade(@ColorWhite, 50%); 0; 1fr; 1fr; center; center);
			}
		}
	}

	/**
	* >= 800px
	*/
	@media all and (min-width: @tablet) {
		.box(grid; auto; auto; none; 1rem; 1fr; auto auto; center; center; column);
	}

	/**
	* >= 1400px
	*/
	@media all and (min-width: @large-screen) {
		.box(grid; auto; auto; none; 1.5rem; 1fr; auto auto; center; center; column);

		& > .Phone {
			.text(@ColorBase; 1em 1rem @medium; none; none none);
		}
		& > .Social {
			.box(grid; auto; auto; none; 1rem; 1fr; auto; center; center; column);
			& > a {
				.box(grid; 2.25rem; 2.25rem; fade(@ColorWhite, 50%); 0; 1fr; 1fr; center; center);
			}
		}
	}
}
</style>
